// What the classic shelf shows while the books load: a short row of books in
// the service's own flavours, standing on the same ledge the shelf has, taking
// turns to lift. The shelf in miniature rather than a spinner, so the screen
// already looks like what it is about to become.
//
// Pure CSS and the palette in base.css - no image, no font of its own - so it
// is on the screen in the frame the theme is known.

const BOOKS = [
  { flavour: '--cherry', height: 64 },
  { flavour: '--tangerine', height: 78 },
  { flavour: '--lemon', height: 58 },
  { flavour: '--lime', height: 72 },
  { flavour: '--raspberry', height: 84 },
  { flavour: '--grape', height: 66 },
  { flavour: '--bubblegum', height: 74 },
];

export default function Loading() {
  return (
    <div className="classic-loading" role="status" aria-label="Loading">
      <div className="classic-loading-shelf">
        <div className="classic-loading-books">
          {BOOKS.map(({ flavour, height }, i) => (
            <span
              key={flavour}
              className="classic-loading-book"
              style={{ background: `var(${flavour})`, height: `${height}px`, animationDelay: `${i * 110}ms` }}
            />
          ))}
        </div>
        <div className="shelf-ledge" />
      </div>
      <p className="eyebrow">Fetching your shelf</p>
    </div>
  );
}
